import axios from "axios";

function api_init(context) {

	let opt = {
		timeout: import.meta.env.VITE_API_TIMEOUT,
	};

	if (import.meta.env.SSR) {
		opt.baseURL = import.meta.env.VITE_API_BASE;

		let ctx = context.get("koaCtx");
		if (ctx) {
			opt.headers = {};

			if (ctx.headers.cookie) {
				opt.headers.cookie = ctx.headers.cookie;
			}

			if (ctx.headers.referer) {
				opt.headers.referer = ctx.headers.referer;
			}

			if (ctx.headers['x-forward-for']) {
				opt.headers['x-forward-for'] = ctx.headers['x-forward-for'];
			}

			if (ctx.headers['user-agent']) {
				opt.headers['user-agent'] = ctx.headers['user-agent'];
			}
		}
	}

	let instance = axios.create(opt);

	if (import.meta.env.SSR) {
		instance.interceptors.request.use(function (config) {
            let t = new URL(config.url, config.baseURL)
            t.pathname = t.pathname.replace(/\.json$/, "");

			config.url = t.toString();

			return config;
		}, function (error) {
			return Promise.reject(error);
		});

		instance.interceptors.response.use(function (response) {
      //console.log(response);

			if (import.meta.env.DEV) {
				//console.log(response.request.path);
				console.log("[axios]", response.request.method, response.request.path, response.status);
			}

			return response;
		}, function (error) {
			if (import.meta.env.DEV) {
				//console.log(error);
			}

			return Promise.reject(error);
		});
	}

	return instance;
}

export { api_init }
